import React, { ReactNode } from "react";

class TableElementProps {
    value: ReactNode;
    className?: string;
    onClick?: () => void;
    blue?: boolean;
    constructor(value: ReactNode, className?: string, onClick?: () => void, blue?: boolean) {
        this.value = value;
        this.className = className;
        this.onClick = onClick;
        this.blue = blue;
    }
}

export default function TableElement(props: TableElementProps) {
    return <a className={(props.className || "") + (props.blue ? " blue" : "")} onClick={props.onClick}>
        {props.value}
    </a>;
}

export {TableElementProps}